import React from "react";

const Tchat = () => {
    return <div className="tchat">

    </div>
}

export default Tchat;